const GET_STARTED_URL = 'https://www.quickcasa.ai/contact/get-started'
const QUICKCASA_HOME_URL = 'https://www.quickcasa.ai'
const QUICKCASA_PRIVACY_URL = 'https://www.quickcasa.ai/privacy'
const QUICKCASA_TERMS_URL = 'https://www.quickcasa.ai/terms'

export {
  GET_STARTED_URL,
  QUICKCASA_HOME_URL,
  QUICKCASA_PRIVACY_URL,
  QUICKCASA_TERMS_URL,
}
